/**
 * Shared portrait-safe UI helpers for village interiors / shell.
 * Buttons use temporary tilesheet UI kit chrome + Phosphor icons.
 */

import Phaser from 'phaser';
import { GAME_WIDTH } from '../config';
import { SAFE_BOTTOM, SAFE_TOP } from './shellUi';
import { addUiButton } from './kit';
import { addGameIcon } from './icons';
import { FONT_DISPLAY, FONT_UI, UI, hexColor } from './theme';

export { SAFE_BOTTOM, SAFE_TOP };

export function addBackToVillageButton(
  scene: Phaser.Scene,
  y: number = SAFE_TOP,
  onClick?: () => void,
): Phaser.GameObjects.Container {
  const btn = addUiButton(
    scene,
    20 + 74,
    y + 20,
    'Village',
    () => {
      if (onClick) {
        onClick();
      } else {
        scene.scene.start('Village');
      }
    },
    { width: 148, height: 44, state: 'normal', fontSize: 16 },
  );
  // Back chevron — separate from button label so art can be swapped later.
  addGameIcon(scene, 'ui.back', 20 + 28, y + 20, {
    size: 18,
    color: UI.parchment,
  });
  return btn;
}

export function addPrimaryButton(
  scene: Phaser.Scene,
  x: number,
  y: number,
  caption: string,
  onClick: () => void,
  width = 200,
): Phaser.GameObjects.Container {
  return addUiButton(scene, x, y, caption, onClick, {
    width,
    height: 48,
    state: 'selected',
    fontSize: caption.length > 22 ? 13 : 16,
  });
}

export function addSecondaryButton(
  scene: Phaser.Scene,
  x: number,
  y: number,
  caption: string,
  onClick: () => void,
  width = 200,
): Phaser.GameObjects.Container {
  return addUiButton(scene, x, y, caption, onClick, {
    width,
    height: 44,
    state: 'alt',
    fontSize: 14,
  });
}

export function titleBlock(
  scene: Phaser.Scene,
  title: string,
  subtitle: string,
  y = SAFE_TOP + 64,
): void {
  const cx = GAME_WIDTH / 2;
  scene.add
    .text(cx, y, title, {
      fontFamily: FONT_DISPLAY,
      fontSize: '28px',
      color: hexColor(UI.goldBright),
      stroke: '#1a1408',
      strokeThickness: 4,
    })
    .setOrigin(0.5);
  scene.add
    .text(cx, y + 36, subtitle, {
      fontFamily: FONT_UI,
      fontSize: '13px',
      color: hexColor(UI.textBody),
      align: 'center',
      wordWrap: { width: GAME_WIDTH - 48 },
    })
    .setOrigin(0.5);
}
